var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination d-flex justify-content-center"},_vm._l((_vm.pages),function(page){return _c('div',{key:page,staticClass:"page p-2",class:{ 'text-dark': _vm.current === page, 'pointer-cursor text-light': _vm.current !== page },on:{"click":function($event){return _vm.jumpTo(page)}}},[_vm._v(_vm._s(page + 1))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }